import { ErrorMessage, Label, Select } from '@iwoca/orion-ui';
import { Field } from 'redux-form';

export const FormFieldSelect = (props) => {
    return <Field component={SelectField} {...props} />;
};

const SelectField = (props) => (
    <div className="my-l">
        <Label htmlFor={props.input.name}>{props.label}</Label>
        <Select
            {...props.input}
            id={props.input.name}
            className={
                props.input.value === '' ? 'font-reg text-[#a9a9a9]' : ''
            }
        >
            <option disabled hidden value="">
                {props.placeholder}
            </option>
            {props.options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </Select>
        {props.meta.touched && props.meta.error && (
            <ErrorMessage className="mt-s">
                <ErrorMessage.Icon />
                <ErrorMessage.Text data-testid="formErrors">
                    {props.meta.error}
                </ErrorMessage.Text>
            </ErrorMessage>
        )}
    </div>
);
